import React, { useState, useContext, useEffect } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import PropTypes from 'prop-types'

export function M_TabsInpage({ type, renderTabs, labelColor, lineBottomTabs, selectedColor, firstTabOpen, hoverSelectedColor, onGetTab }) {
    const [value, setValue] = useState(firstTabOpen || 1)
    const ctx = useContext(LoadingContext)

    labelColor = labelColor || 'var(--color-white)'
    selectedColor = selectedColor || ctx.secondaryColor || 'var(--color-black)'
    hoverSelectedColor = hoverSelectedColor || ctx.tertiaryColor || 'var(--color-black)'
    lineBottomTabs = lineBottomTabs || ctx.tertiaryColor || 'var(--color-grey-light)'

    const changeTab = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        setValue(firstTabOpen || 1);
    }, [firstTabOpen]);

    return (
        <div style={{ width: '100%' }}>
            {type === "tabs" && (
                <Box>
                    <Tabs
                        sx={{
                            '& .MuiTabs-root': {
                                width: '100%',
                            },
                            '& .MuiTabs-flexContainer': {
                                borderBottom: `2px solid ${lineBottomTabs}`,
                                height: '55px',
                                width: '100%'
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: selectedColor,
                                textTransform: 'none',
                                display: 'inherit',
                            },
                            '& .MuiTab-root': {
                                color: hoverSelectedColor,
                                textTransform: 'none',
                                display: 'inherit',
                                fontWeight: 'bold',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: selectedColor,
                            },
                            '& .MuiTab-iconWrapper': {
                                width: '19px',
                            },
                            '& .MuiTabs-scrollButtons.Mui-disabled': {
                                opacity: 1,
                            },
                            '& .MuiTabScrollButton-root': {
                                backgroundColor: "var(--color-white) !important",
                                color: `${ctx.secondaryColor} !important`,
                            },
                            '& .MuiTabScrollButton-root.Mui-disabled': {
                                backgroundColor: "var(--color-white) !important",
                                color: `${ctx.secondaryColor} !important`,
                            },
                        }}
                        value={value}
                        onChange={changeTab}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                    >
                        {renderTabs?.map((tab, index) => (
                            <Tab
                                key={tab.id}
                                value={tab.id}
                                label={tab.labelTab}
                                icon={tab.iconTab}
                                iconPosition="start"
                                disableRipple
                                tabIndex={0}
                                onClick={() => onGetTab(tab.labelTab, tab)}
                                onKeyDown={(event) => {
                                    if (event.code === "Enter") {
                                      onGetTab(tab.labelTab, tab);
                                      setValue(tab.id);
                                    }
                                  }}
                  
                            />
                        ))}
                    </Tabs>
                </Box>
            )}
            {type === "buttons" && (
                <div style={{ width: '100%', padding: '5px', display: 'grid', gridTemplateColumns: `repeat(${renderTabs.length}, 1fr)`, gridColumnGap: '3px' }}>
                    {renderTabs?.map((tab, index) => (
                        <div
                            role='menu'
                            tabIndex={0}
                            style={{
                                background: tab.id === value ? selectedColor : hoverSelectedColor,
                                width: '100%',
                                borderRadius: '5px',
                                height: '40px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                                color: labelColor,
                                fontWeight: 'bold',
                                transition: 'background-color 0.3s',
                            }}
                            key={tab.id}
                            onClick={(event) => {
                                onGetTab(tab)
                                setValue(tab.id)
                                event.currentTarget.style.color = labelColor
                            }}
                            onKeyDown={(event) => {
                                if (event.code === "Enter") {
                                    onGetTab(tab)
                                    setValue(tab.id)
                                    event.currentTarget.style.color = labelColor
                                }
                            }}
                            onMouseEnter={(event) => {
                                if (tab.id !== value) {
                                    event.currentTarget.style.color = selectedColor
                                }
                            }}
                            onMouseLeave={(event) => {
                                if (tab.id !== value) {
                                    event.currentTarget.style.color = labelColor
                                }
                            }}
                            onFocus={(event) => {
                                if (tab.id !== value) {
                                    event.currentTarget.style.color = selectedColor
                                }
                            }}
                            onBlur={(event) => {
                                if (tab.id !== value) {
                                    event.currentTarget.style.color = selectedColor
                                }
                            }}
                        >
                            <div style={{ marginRight: '5px', width: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {tab.iconTab}
                            </div>
                            {tab.labelTab}
                        </div>
                    ))}
                </div>
            )}
            {type === "column" && (
                <div style={{ width: '100%', padding: '5px', borderRight: `3px solid ${ctx.primaryColor}`, }}>
                    {renderTabs?.map((tab, index) => (
                        <div
                            role='menu'
                            tabIndex={0}
                            style={{
                                borderRadius: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                transition: 'background-color 0.3s',
                                margin: '10px',
                                overflowWrap: 'break-word',
                                backgroundColor: tab.id === value ? selectedColor : 'var(--color-grey-light)',
                                color: tab.id === value ? 'var(--color-white)' : 'var(--color-black)',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                paddingLeft: '10px'
                            }}
                            key={index + 1}
                            onClick={(event) => {
                                onGetTab(tab)
                                setValue(tab.id)
                            }}
                            onKeyDown={(event) => {
                                if (event.code === "Enter") {
                                    onGetTab(tab)
                                    setValue(tab.id)
                                }
                            }}
                        >
                            <div style={{
                                marginRight: '7px'
                            }}>
                                {tab.iconTab}
                            </div>
                            {tab.labelTab}
                        </div>
                    ))}
                </div>
            )}
            {renderTabs?.map((tab, index) => (
                <div key={tab.id} style={{ display: tab.id === value ? 'block' : 'none' }}>
                    {tab.renderBody}
                </div>
            ))}
        </div>
    )
}

M_TabsInpage.propTypes = {
    type: PropTypes.oneOf(['tabs', 'buttons', 'column']),
    renderTabs: PropTypes.array,
    labelColor: PropTypes.string,
    lineBottomTabs: PropTypes.string,
    selectedColor: PropTypes.string,
    firstTabOpen: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    hoverSelectedColor: PropTypes.string,
    onGetTab: PropTypes.func
}